import React, { useContext } from 'react';
import { CircularProgress } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import MessagesContext from '../../../contexts/messagesContext';
import useAddPatient from '../../AllPatients/AddPatient';
import { AlertDialog } from '../../UI';
import { styles } from './SearchResult.styles';
import Patient from './Patient';

function PatientResult({ loading }) {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const patients = useSelector((state) => state.patient.patients);
    const { dialog, setDialog, goToPatientPage } = useAddPatient();

    return (
        <>
            <AlertDialog
                open={dialog}
                alertText={messages.alerts.warningNumberOfPatients}
                cancelText={messages.alerts.ok}
                handleClose={() => setDialog(false)}
            />
            <div className={classes.resultContainer}>
                {loading ? (
                    <div className={classes.loadingContainer}>
                        <CircularProgress className={classes.progressRoot} />
                    </div>
                ) : !patients?.length && !loading ? (
                    <div className={classes.loadingContainer}>{messages.noResult}</div>
                ) : (
                    patients.map((patient, index) => (
                        <Patient key={index} patient={patient} goToPatientPage={goToPatientPage} />
                    ))
                )}
            </div>
        </>
    );
}
PatientResult.propTypes = {
    patients: PropTypes.array,
    loading: PropTypes.bool,
    match: PropTypes.object,
    history: PropTypes.object,
    setSelectedPatient: PropTypes.func,
    clearPatients: PropTypes.func
};

export default PatientResult;
